import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CompatibilityPopupComponent } from './shared/components/compatibility-popup/compatibility-popup.component';
import { AppLoadService } from './shared/services/app-load.service';
import { DynamicTitleService } from './shared/services/dynamic-title.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private titleSubscription: Subscription;
  compatibilityDialogRef: MatDialogRef<CompatibilityPopupComponent>;

  constructor(
    private dynamicTitleService: DynamicTitleService,
    private titleService: Title,
    private appLoadService: AppLoadService,
    private dialog: MatDialog
  ) {
    this.handleBrowserCompatibility();
  }

  ngOnInit(): void {
    this.titleSubscription = this.dynamicTitleService.titleUpdated.subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
  }

  handleBrowserCompatibility() {
    if (!this.appLoadService.isCompatible) {
      this.compatibilityDialogRef = this.dialog.open(CompatibilityPopupComponent);

      this.compatibilityDialogRef.afterClosed().subscribe(() => {
        this.compatibilityDialogRef = null;
      });
    }
  }

  ngOnDestroy(): void {
    this.titleSubscription.unsubscribe();
  }
}
